import axiosInstance from 'api/axiosInstance';

export interface DeleteAttachmentResponse {
  success: boolean;
  message?: string;
}

export const deleteAttachment = async (
  fileId: number | string,
  fileType: 'vv' | 'dds' = 'vv'
): Promise<DeleteAttachmentResponse> => {
  try {
    let response;

    if (fileType === 'dds') {
      // DDS files use GET request to different endpoint
      response = await axiosInstance.get(
        `/api2.0/CANDDS/Delete/${fileId}`,
        {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
          },
        }
      );
    } else {
      // VV files use POST request with fileId in body
      response = await axiosInstance.post(
        `/api/fileuploadservice/Delete?FileId=${fileId}`,
        { fileId: Number(fileId) },  // Body must include fileId (lowercase, as number)
        {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
          },
        }
      );
    }

    return { success: true, ...response.data };
  } catch (error: any) {
    console.error('Error deleting attachment:', error);
    console.error('Error response:', error.response?.data);
    throw error;
  }
};

export default deleteAttachment;
